import classNames from "classnames";
import {elementAmount} from "../../../../components/AreaTypes/AreaTypes";
import {components} from "../Components";

const Area = ({formik, settings, childrenItems = []}) => {
    const className = settings.areaType.split("-")[1];

    const divArray = [...Array(elementAmount[className])];

    return (
        <div className={classNames("area", className)}>
            {divArray.map((_, i) => (
                <div key={i} className="box">
                    {childrenItems.length !== 0 && (
                        childrenItems[i]?.map(child => {
                            const ChildComponent = child.type !== "input" ? components[child.type] : components[child.settings.inputType];
                            return (
                                <div key={child.id} className="item">
                                    <ChildComponent id={child.id} formik={formik} settings={child.settings}/>
                                </div>
                            );
                        })
                    )}
                </div>
            ))}
        </div>
    );
};

export default Area;